export default {
    init() {
        // JavaScript to be fired on all pages
        
        document.cookie = 'same-site-cookie=foo; SameSite=Lax';
        document.cookie = 'cross-site-cookie=bar; SameSite=None; Secure';

        $('.slider-postsingle .slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: false,
             fade: true,
             asNavFor: '.slider-nav'
            });
            $('.slider-postsingle .slider-nav').slick({
             slidesToShow: 3,
             slidesToScroll: 1,
             asNavFor: '.slider-for',
             centerMode: true,
             focusOnSelect: true,
             infinite: true,
            });


            $('.slider-blog .slider-for').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             fade: true,
             asNavFor: '.slider-blog .slider-nav',
             adaptiveHeight: true,
             
            });
            $('.slider-blog .slider-nav').slick({
             slidesToShow: 6,
             slidesToScroll: 1,
             arrows:false,
             asNavFor: '.slider-blog .slider-for',
             centerMode: true,
             focusOnSelect: true,
             infinite:true,
            });


            $('.slider').each(function() {
                const $this = $(this);
                let $options = {
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    speed: 1000,
                };

                if($this.hasClass('slider__3')) {
                    $.extend($options, {
                        slidesToShow: 1,
                        centerMode: true,
                        dots: false,
                        arrows: true,
                        // centerPadding: '30%',
                        variableWidth: true,
                        responsive: [
                                {
                                  breakpoint: 600,
                                  settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2
                                  }
                                },
                                {
                                  breakpoint: 480,
                                  settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                  }
                                }
                                // You can unslick at a given breakpoint now by adding:
                                // settings: "unslick"
                                // instead of a settings object
                            ],
                    });
                }

                $this.slick($options);

                });

        //add class on the tab to show the first content directly
        $('#v-pills-tabContent .tab-pane, #pills-tabContent .tab-pane').each(function(i) {
            if ( i === 0 ) {
                $(this).addClass('active show');
            }
        });
        // timeline
        $('.timeline li:odd').addClass('timeline-inverted');


        // // equal matchHeight
        $('.item-biblio').matchHeight();

        // $('.noroboto').attr('href', 'mailto:lchatham@ponderosa-assoc.com?subject=Contact from Ponderosa Website');

        // nav
        // Toggle open and close nav styles on click
        $('#nav-toggle').click(function() {
            $('nav').toggleClass('mask', 1000, 'easeOutSine');
        });
        // Hamburger to X toggle
        $('#nav-toggle').on('click', function() {
            this.classList.toggle('active');
        });



        $('#click-search').click(function(){
             $('#sb-search').addClass('mask');
            });




        // filtre
        $('.subcat-spec').click(function(){
             $('.sub-cat-spectacles').addClass('mask');
            });

        $('.all-cat button:not(.subcat-spec)').click(function() {
            $('.sub-cat-spectacles,.subsub-cat-spectacles').removeClass('mask');
        });

        $('.subsubcat-spec').click(function(){
             $('.subsub-cat-spectacles').addClass('mask');
            });

        $('.all-sub button:not(.subsubcat-spec)').click(function() {
            $('.subsub-cat-spectacles').removeClass('mask');
        });

   
        $('.filter-carte button:not(.expo)').click(function() {
            $('.exposhow').addClass('hide');
        });

        $('button.expo').click(function() {
            $('.exposhow').removeClass('hide');
        });
      

        $('.filter-button').click(function(){
            var value = $(this).attr('data-filter');

            if(value == 'all')
            {
                //$('.filter').removeClass('hidden');
                $('.filter').show('1000');
            }
            else
            {
                $('.filter').not('.'+value).hide('3000');
                $('.filter').filter('.'+value).show('3000');

            }
        });

        if ($('.filter-button').removeClass('active')) {
            $(this).removeClass('active');
        }
        $(this).addClass('active');


     

        // form

        $('.form-control').each(function() {
            const $this = $(this);

            $this.on('focus', function(){
                $this.parents().addClass('focused');
            });

            $this.on('blur', function() {

                const inputValue = $this.val();
                if ( inputValue == "" ) {
                    $this.removeClass('filled');
                    $this.parents('.form-group').removeClass('focused');
                } else {
                    $this.addClass('filled');
                }
            });
        });

        //product
        //
        var lastChecked;

        var $checks = $('input:checkbox').click(function(e) {
            var numChecked = $checks.filter(':checked').length;
            if (numChecked > 3) {
                lastChecked.checked = false;
            }
            lastChecked = this;
        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $(".my-paroller, [data-paroller-factor]").paroller({
                factor: 0.3,            // multiplier for scrolling speed and offset
                factorXs: 0.1,          // multiplier for scrolling speed and offset if window width is <576px
                factorSm: 0.2,          // multiplier for scrolling speed and offset if window width is <=768px
                factorMd: 0.2,          // multiplier for scrolling speed and offset if window width is <=1024px
                factorLg: 0.3,          // multiplier for scrolling speed and offset if window width is <=1200px
                type: 'background',     // background, foreground
                direction: 'vertical' // vertical, horizontal
            });

    const AOS = require('aos');
    AOS.init({
        disable: 'mobile'
    });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js